module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"common\" class=\"tab-pane fade active in\">\r\n    <p>Common tools here</p>\r\n</div>\r\n<div id=\"input\" class=\"tab-pane fade\">\r\n    <p>Input tools here</p>\r\n</div>\r\n<div id=\"buttons\" class=\"tab-pane fade\">\r\n\r\n</div>\r\n<div id=\"layout\" class=\"tab-pane fade\">\r\n    <p>Layout tools here</p>\r\n</div>\r\n<div id=\"containers\" class=\"tab-pane fade\">\r\n    <p>Containers tools here</p>\r\n</div>\r\n<div id=\"assets\" class=\"tab-pane fade\">\r\n    <p>Assets tools here</p>\r\n</div>\r\n<div id=\"reporting\" class=\"tab-pane fade\">\r\n    <p>Reporting tools here</p>\r\n</div>\r\n<div id=\"all\" class=\"tab-pane fade\">\r\n\r\n\r\n</div>")
  }
  return __output;

}